import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-export-action-circle2',
    templateUrl: './export-action-circle2.component.html',
    styleUrls: [
        './export-action-circle2.component.scss'
    ],
    standalone: false
})
export class ExportActionCircle2Component
{
    @Input() cta: () => void;
}
